import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DocumentViewerStoreService {
  private entityData: any | null = null;

  store(data: any): void {
    this.entityData = data;
  }

  retrieve(): any | null {
    return this.entityData;
  }

  clear(): void {
    this.entityData = null;
  }
}
